
const riskLevels = [
  {
    level: "Low",
    range: "0-39",
    color: "#62a228",
  },
  {
    level: "Medium",
    range: "40-69",
    color: "#fe841c",
  },
  {
    level: "High",
    range: "70-89",
    color: "#fc4028",
  },
  {
    level: "Critical",
    range: "90-100",
    color: "#e22223",
  },
];

export function RiskScoreInfoBar() {
  return (
    <div className="rounded-lg border bg-card px-4 py-3 mt-4">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-foreground">Risk score levels</p>
          <p className="text-xs text-muted-foreground">
            Score ranges used across the system.
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          {riskLevels.map((risk) => (
            <div
              key={risk.level}
              className="inline-flex items-center gap-2 rounded-md border px-3 py-2 bg-background"
            >
              <span
                className="h-2.5 w-2.5 rounded-full shrink-0"
                style={{ backgroundColor: risk.color }}
              />
              <span className="text-sm font-medium text-foreground">{risk.level}</span>
              <span className="text-xs text-muted-foreground">({risk.range})</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
